import { CAMERA_ID_KEY, MICROPHONE_ID_KEY, SPEAKER_ID_KEY } from "@/utils/constant";
import { ActionTree } from "vuex";
import { AppState, AppView, LayoutType, ToastData, UserRole } from "./state";
import { defineVuexName, MODULES, vuexName } from "../utils";

const actions: ActionTree<AppState, any> = {
  setToast(store, payload: ToastData) {
    store.dispatch(vuexName(MODULES.APP.DISPATCHES.SET_TOAST, false), payload);
  },
  //setToast
  [defineVuexName(MODULES.APP.DISPATCHES.SET_TOAST)](store, payload: ToastData) {
    store.commit(vuexName(MODULES.APP.COMMITS.SET_TOAST, false), payload);
  },
  setLayout(store, payload: { layout: LayoutType }) {
    store.dispatch(vuexName(MODULES.APP.DISPATCHES.SET_LAYOUT, false), payload);
  },
  //setLayout
  [defineVuexName(MODULES.APP.DISPATCHES.SET_LAYOUT)](store, payload: { layout: LayoutType }) {
    store.commit(vuexName(MODULES.APP.COMMITS.SET_LAYOUT, false), payload);
  },
  setAppView(store, payload: { appView: AppView }) {
    store.dispatch(vuexName(MODULES.APP.DISPATCHES.SET_APP_VIEW, false), payload);
  },
  //setAppView
  [defineVuexName(MODULES.APP.DISPATCHES.SET_APP_VIEW)](store, payload: { appView: AppView }) {
    store.commit(vuexName(MODULES.APP.COMMITS.SET_APP_VIEW, false), payload);
  },
  async setCameraDeviceId(store, payload: string) {
    store.dispatch(vuexName(MODULES.APP.DISPATCHES.SET_CAMERA_DEVICE_ID, false), payload);
  },
  //setCameraDeviceId
  async [defineVuexName(MODULES.APP.DISPATCHES.SET_CAMERA_DEVICE_ID)](store, payload: string) {
    localStorage.setItem(CAMERA_ID_KEY, payload);
    store.commit(vuexName(MODULES.APP.COMMITS.SET_CAMERA_DEVICE_ID, false), payload);
  },
  async setMicrophoneDeviceId(store, payload: string) {
    store.dispatch(vuexName(MODULES.APP.DISPATCHES.SET_MICROPHONE_DEVICE_ID, false), payload);
  },
  //setMicrophoneDeviceId
  async [defineVuexName(MODULES.APP.DISPATCHES.SET_MICROPHONE_DEVICE_ID)](store, payload: string) {
    localStorage.setItem(MICROPHONE_ID_KEY, payload);
    store.commit(vuexName(MODULES.APP.COMMITS.SET_MICROPHONE_DEVICE_ID, false), payload);
  },
  async setSpeakerDeviceId(store, payload: string) {
    store.dispatch(vuexName(MODULES.APP.DISPATCHES.SET_SPEAKER_DEVICE_ID, false), payload);
  },
  //setSpeakerDeviceId
  async [defineVuexName(MODULES.APP.DISPATCHES.SET_SPEAKER_DEVICE_ID)](store, payload: string) {
    localStorage.setItem(SPEAKER_ID_KEY, payload);
    store.commit(vuexName(MODULES.APP.COMMITS.SET_SPEAKER_DEVICE_ID, false), payload);
  },
  setHavePermissionCamera(store, payload: boolean) {
    store.commit(vuexName(MODULES.APP.COMMITS.SET_HAVE_PERMISSION_CAMERA, false), payload);
  },
  setHavePermissionMicrophone(store, payload: boolean) {
    store.commit(vuexName(MODULES.APP.COMMITS.SET_HAVE_PERMISSION_MICROPHONE, false), payload);
  },
  setUserRoleByView(store, payload: UserRole) {
    store.dispatch(vuexName(MODULES.APP.DISPATCHES.SET_USER_ROLE_BY_VIEW, false), payload);
  },
  //setUserRoleByView
  [defineVuexName(MODULES.APP.DISPATCHES.SET_USER_ROLE_BY_VIEW)](store, payload: UserRole) {
    store.commit(vuexName(MODULES.APP.COMMITS.SET_USER_ROLE_BY_VIEW, false), payload);
  },
  setLowBandWidth(store, payload: boolean) {
    store.dispatch(vuexName(MODULES.APP.DISPATCHES.SET_LOW_BAND_WIDTH, false), payload);
  },
  //setLowBandWidth
  [defineVuexName(MODULES.APP.DISPATCHES.SET_LOW_BAND_WIDTH)](store, payload: boolean) {
    store.commit(vuexName(MODULES.APP.COMMITS.SET_LOW_BAND_WIDTH, false), payload);
  },
  setLowBandWidthDueToDownlink(store, payload: boolean) {
    store.commit("setLowBandWidthDueToDownlink", payload);
  },
};

export default actions;
